import {useDispatch,useSelector} from 'react-redux';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import {setAction} from './redux/appState';
import {useState} from 'react';
import {useCheckPermissionsQuery} from './redux/databaseView';
import Box from '@mui/material/Box';


export function SubMenu(props)
	{
	const validFunctions=useSelector(
		(state)=>state.appState.validFunctions
		);

	const permissions=useCheckPermissionsQuery();

	let menuList=props.menuList;

	const dispatch=useDispatch();

	const [anchorEl,setAnchorEl]=useState(null);
	const [open,setOpen]=useState(false);


	if (!permissions.isSuccess)
		return null;


	const roles=permissions.data.data.roles;


	function handleClick(event)
		{
		setAnchorEl(event.currentTarget);
		}


	function handleClose()
		{
		setAnchorEl(null);
		setOpen(null);
		}


	function menuClick(key)
		{
		props.executeFunction
			?props.executeFunction(key)
			:dispatch(setAction(key));

		handleClose();
		}


	/*
	 * Apply permissions first.
	 */

	menuList=menuList.filter((x)=>
		{
		if (typeof x==='string')
			return true;

		if (x.permission&&!x.permission(roles))
			return false;

		return true;
		});


	/*
	 * Apply contextual function filtering.
	 */

	if (props.filter&&validFunctions)
		{
		menuList=menuList.filter((x)=>
			{
			const name=
				typeof x==='string'
					?x
					:x.name;

			const index="on"+name;

			return validFunctions[index]!==undefined;
			});
		}


	/*
	 * Flat toolbar mode.
	 */

	if (props.flat)
		{
		if (!menuList.length)
			return null;


		const primary=[];
		const secondary=[];


		menuList.forEach((x)=>
			{
			const name=
				typeof x==='string'
					?x
					:x.name;


			if (
				name==="DataXChange"||
				name==="Delete"
				)
				secondary.push(name);
			else
				primary.push(name);
			});


		const moreOpen=open==="__more";


		return (
			<Box
				sx={{
					display:'flex',
					alignItems:'center',
					minHeight:36,
					px:2,
					borderTop:'1px solid',
					borderColor:'divider'
					}}
				>
				{primary.map(name=>
					<Button
						key={name}
						onClick={()=>menuClick(name)}
						color="inherit"
						sx={{
							px:0,
							mx:1.25,
							minWidth:0,
							textTransform:'none',
							fontSize:'14px',
							fontWeight:400,
							color:'text.secondary'
							}}
						>
						{name}
					</Button>
					)
				}


				{secondary.length>0 &&
					<>
						<Button
							color="inherit"
							aria-label="More actions"
							onClick={(event)=>
								{
								setOpen("__more");
								handleClick(event);
								}}
							sx={{
								minWidth:36,
								px:0.5
								}}
						>
							<MoreHorizIcon/>
						</Button>


						<Menu
							anchorEl={anchorEl}
							open={moreOpen}
							onClose={handleClose}
						>
							{secondary.map(name=>
								<MenuItem
									key={name}
									onClick={()=>menuClick(name)}
									sx={{
										fontSize:'1rem',
										minHeight:44
										}}
								>
									{name}
								</MenuItem>
								)
							}
						</Menu>
					</>
				}
			</Box>
			);
		}


	/*
	 * Original dropdown mode.
	 */

	const disabled=menuList.length===0;
	const openVal=open===props.name;


	return (
		<>
			<Button
				id="basic-button"
				sx={{
					float:'left',
					textTransform:'none',
					fontSize:'15px',
					fontWeight:500
					}}
				aria-controls={
					openVal
						?'basic-menu'
						:undefined
					}
				aria-haspopup="true"
				aria-expanded={
					openVal
						?'true'
						:undefined
					}
				disabled={disabled}
				onClick={(event)=>
					{
					setOpen(props.name);
					handleClick(event);
					}}
			>
				{props.name}
			</Button>


			<Menu
				id={props.name+"basic-menu"}
				anchorEl={anchorEl}
				open={openVal}
				onClose={handleClose}
				slotProps={{
					list:{
						'aria-labelledby':'basic-button'
						}
					}}
			>
				{menuList.map((x)=>
					{
					const name=
						typeof x==='string'
							?x
							:x.name;

					return (
						<MenuItem
							key={name}
							id={name}
							sx={{
								fontSize:'1rem',
								minHeight:44
								}}
							onClick={()=>menuClick(name)}
						>
							{name}
						</MenuItem>
						);
					})
				}
			</Menu>
		</>
		);
	}